module.exports = __webpack_public_path__ + "static/media/171IT237.383e6438.jpg";